import type { PickerForest } from '@/entities/optimization-group'
import type { OptimizationGroupModel, ScenarioModel } from '@/shared/generated'
import type { TreeNodeType } from '@/shared/lib/tree'

import { canonicalizeMapping } from '@/entities/optimization-group'

import { findNodes, getChildrenIds } from '@/shared/lib/tree'

export const buildFormDefaultValue = ({
	optimizationGroup,
	pickerForest,
	salesEntitiesTree,
	scenario,
}: {
	optimizationGroup: OptimizationGroupModel
	pickerForest: PickerForest
	salesEntitiesTree: TreeNodeType[]
	scenario: ScenarioModel
}) => {
	const { sales_entities, product_groups } = optimizationGroup

	return {
		name: optimizationGroup.name,
		description: optimizationGroup.description ?? '',
		sales_entities: getChildrenIds(
			findNodes(salesEntitiesTree, sales_entities)
		),
		// Canonical form, so undoing a picker change clears `isDirty` again.
		product_groups: canonicalizeMapping(pickerForest, product_groups),
		optimization_group_id: optimizationGroup.id,
		...scenario.settings,
		business: {
			...scenario.settings.business,
			optimize_discount_price: false,
		},
	}
}
